module.exports = __webpack_public_path__ + "static/media/subICloud3.aa230d40.png";